import { render, staticRenderFns } from "./ShowBarChartLegend.vue?vue&type=template&id=7bb5fe3a"
import script from "./ShowBarChartLegend.vue?vue&type=script&lang=js"
export * from "./ShowBarChartLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports